import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import './Login.css';
import { DSInput, DSIcon, DSButton } from '../design-system/primitives';

const API_URL = process.env.REACT_APP_API_URL || '/api';

function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setMessage('');
    setIsLoading(true);

    try {
      const response = await axios.post(`${API_URL}/auth/forgot-password`, { email });
      setMessage(response.data.message);
      setSubmitted(true);
    } catch (err) {
      setError(err.response?.data?.error || 'Failed to send reset email. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-container">
        <div className="login-header">
          <img src="/logo.png" alt="Capital Pinball" className="login-logo" />
        </div>

        <form onSubmit={handleSubmit} className="login-form">
          <h2 style={{ color: 'var(--ds-color-textDefault)', marginBottom: '10px', fontSize: '20px', textAlign: 'center' }}>
            Forgot Password
          </h2>

          {!submitted ? (
            <>
              <p style={{ fontSize: '14px', color: 'var(--ds-color-textMuted)', textAlign: 'center', marginBottom: '20px' }}>
                Enter your email address and we'll send you a link to reset your password.
              </p>

              {error && <div className="alert alert-error">{error}</div>}

              <DSInput label="Email Address"
                  type="email"
                  id="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  autoFocus
                  disabled={isLoading}
                  placeholder="Enter your email" />

              <DSButton tone="primary" appearance="solid" className="login-button" type="submit" disabled={isLoading}>
                {isLoading ? 'Sending...' : 'Send Reset Link'}
              </DSButton>
            </>
          ) : (
            <div style={{ textAlign: 'center' }}>
              <div style={{
                backgroundColor: 'var(--ds-color-statusSuccessBg)',
                border: '1px solid var(--ds-color-statusSuccessText)',
                padding: '20px',
                borderRadius: '5px',
                marginBottom: '20px',
                color: 'var(--ds-color-statusSuccessText)'
              }}>
                <div style={{ fontSize: '24px', marginBottom: '10px' }}><DSIcon name="mail" /></div>
                <strong>Check your email</strong>
                <p style={{ margin: '10px 0 0 0', fontSize: '14px' }}>
                  {message}
                </p>
              </div>

              <p style={{ fontSize: '13px', color: 'var(--ds-color-textMuted)' }}>
                Didn't receive the email? Check your spam folder or{' '}
                <button
                  type="button"
                  onClick={() => {
                    setSubmitted(false);
                    setMessage('');
                  }}
                  style={{
                    color: 'var(--ds-global-color-pink500)',
                    background: 'none',
                    border: 'none',
                    padding: 0,
                    cursor: 'pointer',
                    textDecoration: 'underline',
                    font: 'inherit'
                  }}
                >
                  try again
                </button>
              </p>
            </div>
          )}
        </form>

        <div className="login-footer">
          <p>
            Remember your password? <Link to="/login">Login</Link>
          </p>
        </div>
      </div>
    </div>
  );
}

export default ForgotPassword;
